import { authClientOptions } from '@/pages/api/auth/[...nextauth]';
import { GetServerSideProps } from 'next';
import { getServerSession } from 'next-auth';
import authUtils from 'utils/auth';
import { SecondSignUpScreen } from '@/components/screens/auth/second-signup';

const SignUp = (): JSX.Element => {
	return <SecondSignUpScreen />;
};

// If user already has a session
export const getServerSideProps: GetServerSideProps = async (context) => {
	let redirectPath = undefined;

	// const session = await getSession(context);
	const session = await getServerSession(
		context.req,
		context.res,
		authClientOptions
	);

	const role = session?.user.user?.role;
	if (session && session.user && role && role === 'client')
		redirectPath = {
			destination: authUtils.getPathToRedirectLoggedClient(),
			permanent: false,
		};

	context.res.setHeader('Cache-Control', 'private, no-cache, must-revalidate');

	return {
		props: {},
		redirect: redirectPath,
	};
};

export default SignUp;
